import { render, staticRenderFns } from "./TabulateTraffic.vue?vue&type=template&id=30641fde&"
import script from "./TabulateTraffic.vue?vue&type=script&lang=js&"
export * from "./TabulateTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports